import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import GlobalWrapper from '../../components/Wrapper/GlobalWrapper';
import { getStudentPortalLeads } from '../../redux/features/studentPortalSlice';
import { STUDENT_LEADS_TABLE_HEAD } from '../../components/datagrid/studentPortal/StudentLeads';
import GlobalDatagrid from '../../components/mui/DataGrid/GlobalDatagrid';

const StudentPortalLeads = ({ cro }) => {
  const dispatch = useDispatch();
  const { portalLeads, loading } = useSelector((state) => state.studentPortal);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, search } = paginationData;

  // The assessment report opens from its own "View report" column
  // (ViewAssessmentReport), not from a row click — so this view holds no
  // selection state of its own.
  const searchParams = {
    page: pageNum,
    limit: gridSize,
    search: search,
  };

  useEffect(() => {
    dispatch(getStudentPortalLeads(searchParams));
  }, [pageNum, gridSize, search]);

  return (
    <GlobalWrapper title={'Student Portal Leads'}>
      <Box sx={{ width: '100%', padding: 0 }}>
        <GlobalDatagrid
          tableHead={STUDENT_LEADS_TABLE_HEAD}
          rows={portalLeads?.data}
          loading={loading}
          rowUniqueId="sl_no"
          rowClick={true}
          meta={portalLeads?.meta?.totalRecords || 0}
        />
      </Box>
    </GlobalWrapper>
  );
};

export default StudentPortalLeads;
